import React, { Component } from 'react';
import { generateKey, removeSpacing } from '../../utils/utils.js'
import { Link } from 'react-router-dom'
import AnimateCursor from './AnimatedCursor';
import * as Carousel from './styles/index'
import RichText from './Components/RichText'

class CarouselRefined extends Component {
  state = {
    counter: 0,
    windowWidth: window.innerWidth
  }

  componentDidMount() {
    let mainContent = this.props.children.content.filter((content) => {
      if (content.nodeType === "paragraph" && content.content[0].value === "") {
        return false;
      }
      return true;
    })
    this.setState({
      mainContent: mainContent.length
    })
  }

  nextVideo = () => {
    this.setState(prev => ({
      counter: prev.counter < prev.mainContent ? prev.counter + 1 : 0
    }));
  }
  prevVideo = () => {
    this.setState(prev => ({
      counter: prev.counter > 0 ? prev.counter - 1 : prev.mainContent
    }));
  }
  render() {
    let carouselContent = this.props.children.content.filter((content) => {
      if (content.nodeType === "paragraph" && content.content[0].value === "") {
        return false;
      }
      return true;
    })

    carouselContent.unshift(
      <div>
        <h1>{this.props.postContent.fields.title}</h1>
        <h2>{this.props.postContent.fields.subHeader}</h2>
      </div>
    );
    carouselContent = carouselContent.map((content, index) => {
      if (index === this.state.counter && content) return <RichText key={generateKey(index)} content={content} index={index} />
    });

    return (
      <Carousel.Container>
        {this.state.windowWidth > 768 &&
          <AnimateCursor />
        }
        <Carousel.Next className="carousel__next" onClick={this.nextVideo}></Carousel.Next>
        <Carousel.Prev className="carousel__prev" onClick={this.prevVideo}></Carousel.Prev>
        {carouselContent}
        <Carousel.Counter>{this.state.counter + 1} / {this.state.mainContent + 1}</Carousel.Counter>
        <Carousel.PostTitle>
          {this.props.postContent.fields.title}
        </Carousel.PostTitle>
        <Carousel.NextProject >
          <Link to={`${removeSpacing(this.props.next ? '/project/' + this.props.next.fields.title : '')}`}>
            {this.props.next ? "NEXT PROJECT" : ''}<h3>
              <span>{this.props.next ? ' : ' : ''}</span>
              {this.props.next ? `${this.props.next.fields.title}` : 'RETURN HOME'}</h3>
          </Link>
        </Carousel.NextProject>
      </Carousel.Container>
    );
  }
}

export default CarouselRefined;


// WEBPACK FOOTER //
// ./src/Posts/elements/CarouselRefined.js